import React from "react";

class ApMobileZoom extends React.Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    if (this.state.width > this.state.height) {
      return this.renderVertical();
    } else {
      return this.renderHorizontal();
    }
  }

  zoom(difference) {
    this.props.zoom(difference * 0.1);
  }

  rotate() {
    this.props.rotate();
  }

  renderHorizontal() {
    return (
      <div className="ApMobileZoom-H">
        <i
          id="BtnZoomIn"
          className="fas fa-search-plus"
          onClick={() => this.zoom(1)}
        />
        <i
          id="BtnZoomOut"
          className="fas fa-search-minus"
          onClick={() => this.zoom(-1)}
        />
        <i
          id="BtnRotate"
          className="fas fa-sync-alt"
          onClick={() => this.rotate()}
        />
      </div>
    );
  }

  renderVertical() {
    return (
      <div className="ApMobileZoom-V">
        <i
          id="BtnZoomIn"
          className="fas fa-search-plus"
          onClick={() => this.zoom(1)}
        />
        <i
          id="BtnZoomOut"
          className="fas fa-search-minus"
          onClick={() => this.zoom(-1)}
        />
        <i
          id="BtnRotate"
          className="fas fa-sync-alt"
          onClick={() => this.rotate()}
        />
      </div>
    );
  }
}

export default ApMobileZoom;



// WEBPACK FOOTER //
// ./src/components/approval/mobile/ApMobileZoom.js